import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {ReactNode} from "react";
import type React from "react";
import {memo, useCallback} from "react";
import type {LayoutChangeEvent} from "react-native";

import {useView, type View} from "../../hooks/useView";
import {Box} from "../ui/box";

type Props = {
    children: ReactNode;
} & StrictUnion<
    | {
          isSticky: true;
          onLayoutChange: (value: number) => void;
      }
    | {
          isSticky?: false;
      }
>;

const style = tva({
    base: "bg-background-0 px-5 py-4 border-t border-solid border-blueGray-200 items-end",
    variants: {
        view: {
            native: "",
            webMobile: "",
            webDesktop: ""
        } satisfies Record<View, string>
    }
});

const ModalFooter: React.FC<Props> = ({isSticky, children, onLayoutChange}) => {
    const view = useView();

    const handleLayout = useCallback(
        (evt: LayoutChangeEvent) => {
            if (isSticky) {
                onLayoutChange(evt.nativeEvent.layout.height);
            }
        },
        [isSticky, onLayoutChange]
    );

    const className = style({
        view
    });
    return process.env.IS_WEB ? (
        <Box className={className}>{children}</Box>
    ) : isSticky ? (
        <Box className={className} onLayout={handleLayout}>
            {children}
        </Box>
    ) : (
        <Box className={className}>{children}</Box>
    );
};

export default memo(ModalFooter);
